export const RESET_SKILLS = "RESET_SKILLS";
export const RESET_SKILL = "RESET_SKILL";
export const RESET_ERROR = "SKILLS_RESET_ERROR";

export const GET_SKILLS = "GET_SKILLS";
export const SET_SKILLS = "SET_SKILLS";

export const API_ERROR = "SKILLS_API_ERROR";

export const GET_SKILL = "GET_SKILL";
export const SET_SKILL = "SET_SKILL";

export const EDIT_SKILL = "EDIT_SKILL";
export const EDIT_SKILL_SUCCESS = "EDIT_SKILL_SUCCESS";

export const CREATE_SKILL = "CREATE_SKILL";
export const CREATE_SKILL_SUCCESS = "CREATE_SKILL_SUCCESS";

export const DELETE_SKILL = "DELETE_SKILL";
export const DELETE_SKILL_SUCCESS = "DELETE_SKILL_SUCCESS";
